import { Component, OnInit, Input, ElementRef, HostListener, ViewEncapsulation, OnDestroy, HostBinding, ViewChild } from '@angular/core';
import { VgAPI, VgFullscreenAPI, VgControlsHidden, VgStates } from 'videogular2/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/timer';

@Component({
    selector: 'vg-up-next',
    encapsulation: ViewEncapsulation.None,
    templateUrl: `./vg-up-next.template.html`,
    styleUrls: ['./vg-up-next.style.scss']
})
export class VgUpNext implements OnInit, OnDestroy {
    @Input() vgFor: string;
    @Input() video: any;
    @Input() poster: string;

    private target: any;
    private subscriptions: Array<any> = [];
    private countdown$: Observable<any>;
    private cancel$: Subject<any>;
    private timeout: number = 5; //timeout to next redirect in seconds    
    private style: any = {};
    private canceled:boolean;

    constructor(private el: ElementRef,
        public API: VgAPI,
        private router: Router) { }

    ngOnInit() {
        if (this.API.isPlayerReady) {
            this.onPlayerReady();
        }
        else {
            this.subscriptions.push(this.API.playerReadyEvent.subscribe(() => this.onPlayerReady()));
        }
        if (this.poster) {
            this.style["background-image"] = `url(${this.poster})`;
        }
    }

    ngAfterViewInit() {
        //setup countdown and cancellation logic
        this.cancel$ = new Subject<any>();
        this.countdown$ = Observable.timer(0, 1000)
            .take(this.timeout)
            .do(this.checkCountdown.bind(this))
            .map(val => this.timeout - val)
            .takeUntil(this.cancel$)
    }

    private onPlayerReady() {
        this.target = this.API.getMediaById(this.vgFor);
    }

    getState() {
        return this.target ? this.target.state : VgStates.VG_PLAYING;
    }

    isActive(): boolean {
        return this.getState() === 'ended';
    }

    private checkCountdown(count) {
        if (count + 1 === this.timeout && this.video.internal_route) {
            this.openVideo();
        }
    }

    private openVideo() {
        setTimeout(() => {
            this.navigate(this.video.internal_route);
        }, 250);
    }

    private navigate(url) {
        url = (this.router.url.indexOf('embed/') > -1 && url.indexOf('embed/') < 0) ? '/embed' + url : url;
        this.router.navigateByUrl(url);
    }

    private toggleCancel() {
        if (!this.canceled){
           this.cancel$.next(true)
           this.canceled = true;
        }
        else {
            this.openVideo();
        }
    }

    ngOnDestroy() {
        if(this.subscriptions)
        {
            this.subscriptions.forEach(s => s.unsubscribe());
        }

        if(this.cancel$)
        {
            this.cancel$.next();
            this.cancel$.complete();
            this.cancel$.unsubscribe();
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/controls/up-next/vg-up-next.component.ts